import { render, staticRenderFns } from "./kpi-basic-tasks.vue?vue&type=template&id=1ece913a"
import script from "./kpi-basic-tasks.vue?vue&type=script&lang=js"
export * from "./kpi-basic-tasks.vue?vue&type=script&lang=js"
import style0 from "./kpi-basic-tasks.vue?vue&type=style&index=0&id=1ece913a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports